<template>
  <section>
    <h1 class="responsive">
      Browser Allowed are
      <span class="os-allowed"> Chrome &ge; 69, Mozilla &ge; 68</span>
    </h1>
  </section>
</template>
<script>
export default {
  name: 'StepsBrowser',
}
</script>
<style scoped>
.responsive {
  font-size: 3vh;
}
.os-allowed {
  color: rgb(103, 189, 103);
}
</style>
